import type { SpecialsData } from '@/data/types';

interface SpecialsProps {
  data: SpecialsData;
}

export function Specials({ data }: SpecialsProps) {
  return (
    <section className="bg-gray-800 text-white py-16">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-red-500 text-center mb-12">
          {data.title}
        </h2>
        
        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {data.specials.map((special, index) => (
            <div key={index} className="bg-gray-700 rounded-lg p-6">
              <h3 className="text-xl font-semibold text-red-400 mb-4">
                {special.title}
              </h3>
              <p className="text-gray-300 leading-relaxed">
                {special.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}